const AUTH_URL = process.env.REACT_APP_AUTH_URL;
const realm = process.env.REACT_APP_REALM;
const GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL;
const DOMAIN_URL = process.env.REACT_APP_DOMAIN_URL;

export const APP_CONFIGS = {
  GATEWAY_URL: GATEWAY_URL,
  GET_TOKEN_SERVER: AUTH_URL + `/realms/${realm}/protocol/openid-connect/token`,
  UPLOAD_FILE_SERVER: "https://app.smartvendingmachines.net/files/image",
  SSO_URL: AUTH_URL + `/realms/${realm}`,
  GET_TOKEN_URL_SUFFIX: "/protocol/openid-connect/",
  DOMAIN_APP: DOMAIN_URL + "/statistical",
  REDIRECT_URL:
    AUTH_URL +
    `/realms/${realm}/protocol/openid-connect/auth?client_id=web&response_type=code&scope=offline_access&redirect_uri=`,
  SOCKET_URL: "https://app.smartvendingmachines.net/ws",
};
